/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Sep 11 2023
 **/

import React, { ElementRef, forwardRef } from "react";

import { Column } from "@/frameworks/designStuff/components";
import { SidebarID } from "@/frameworks/core/commons";

import * as S from "./emotion";
import SidebarOverlay from "./SidebarOverlay";

export type SidebarOption = {
	width: UnitString;
	direction: "left" | "right";
	startX?: UnitString | "-webkit-fill-available";
	overlay?: boolean;
};

interface SidebarProps extends React.HTMLAttributes<HTMLDivElement> {
	depth: number;
	isOpen: boolean;
	body: JSX.Element;
	option: SidebarOption;
	sidebarId: SidebarID;
}

const Sidebar = forwardRef<ElementRef<typeof Column>, SidebarProps>((props, ref) => {
	const { body, isOpen, option, ...rest } = props;
	return (
		<Column css={S.drawerAnimationCss(option, isOpen)} {...rest} ref={ref}>
			{body}
			{option.overlay && <SidebarOverlay />}
		</Column>
	);
});

export default Sidebar;
